import { createSelector } from 'reselect'

export const selectEnvironment = () => {
  const { environment: ENVIRONMENT } = APP_CONFIG
  return ENVIRONMENT
}

export const selectEnvironmentName = createSelector(
  selectEnvironment,
  environment => environment.name
)

export const selectIsDevelopment = createSelector(
  selectEnvironmentName,
  environmentName => environmentName === 'development'
)

export const selectEnvironmentUrl = createSelector(
  selectEnvironment,
  environment => environment.url
)

export const selectEnvironmentUrlTemplate = createSelector(
  selectEnvironment,
  environment => environment.urlTemplate
)

export const selectEnvironmentWidgetUuid = createSelector(
  selectEnvironment,
  environment => environment.widgetUuid
)
